import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ListadoOrdenes } from "../models/ordenes-sb";

/*import { environment } from '../../../environments/environment.development';*/


@Injectable({
  providedIn: 'root'
})
export class ApiUrlService {

  get keyVaultApi(): string { return `${this.urlApiEndV3}/key-vault`; }

  get sentinelApi(): string { return `${this.urlApiEndV3}/minerva/sentinel`; }
  get argosApi(): string { return `${this.urlApiEndV3}/minerva/argos`; }
  get hermesApi(): string { return `${this.urlApiEndV3}/minerva/hermes`; }

  get loadMonitorApi(): string { return this.sentinelApi; }
  get datagraphApi(): string { return this.argosApi; }
  get hermesCostDashboardApi(): string { return `${this.hermesApi}/cost-dashboard`; }
  get hermesMetadataApi(): string { return `${this.hermesApi}/metadata`; }
  get hermesTrainingApi(): string { return `${this.hermesApi}/training`; }
  get hermesTrainingUpdateApi(): string { return `${this.hermesApi}/training/update`; }
  get hermesTrainingEmbedApi(): string { return `${this.hermesApi}/training/embed`; }


  // Normalize to avoid accidental double slashes when endpoints start with "/"
  private urlApiEndV3: string = environment.urlApiEndPointV3.replace(/\/+$/, '');

  private readonly FIXEDAPIV3: string = '/api/v3';

  //LOGIN//

  private readonly LOGIN_USER_API_END: string = '/user-management/user-info-recover';
  private readonly CURRENT_USER_API_END: string = '/user-management/me';
  private readonly USERS_API_END: string = '/user-management/users';

  get loginUserApiEnd(): string {
    return `${this.urlApiEndV3}${this.LOGIN_USER_API_END}`;
  }

  get currentUserApiEnd(): string {
    return `${this.urlApiEndV3}${this.CURRENT_USER_API_END}`;
  }

  get usersApiEnd(): string {
    return `${this.urlApiEndV3}${this.USERS_API_END}`;
  }

  private readonly TOKEN_USER_API_END: string = '/token';

  get tokenUserApiEnd(): string {
    return `${this.urlApiEndV3}${this.TOKEN_USER_API_END}`;
  }

  private readonly STATUS_USER_API_END: string = '/status';

  get statusUserApiEnd(): string {
    return `${this.urlApiEndV3}${this.STATUS_USER_API_END}`;
  }

  //PENDIENTE CLASIFICAR//TODO

  private readonly GLOBAL_STATUS_API_END: string = '/app-status-management/get-global-status'
  private readonly EXECUTION_REG_API_END: string = '/order-management/get-execution-reg'
  private readonly ADD_EXECUTION_REG_API_END: string = '/order-management/add-execution-reg'
  private readonly DELETE_EXECUTION_REG_API_END: string = '/order-management/delete-execution-reg'
  private readonly USER_INFO_RECOVER_API_END: string = '/app-status-management/user-info-recover'
  private readonly PACKAGE_INFO_API_END: string = '/package-management/get-package-reg'
  private readonly UPDATE_PACKAGE_API_END: string = '/package-management/update-package-reg'
  private readonly INSERT_PACKAGE_API_END: string = '/package-management/insert-package-reg'
  private readonly DELETE_PACKAGE_API_END: string = '/package-management/delete-package-reg'
  private readonly GROUP_CATALOG_API_END: string = '/group-management/catalog'
  private readonly GROUP_MEMBERSHIPS_API_END: string = '/group-management/memberships'
  private readonly GROUP_CONFIGURATION_API_END: string = '/group-management/configuration'
  private readonly SAVE_PACKAGE_CONFIGURATION_API_END: string = '/package-management/save-package-configuration'
  private readonly INFO_PHARMACIA_API_END: string = '/pharma-info-management/get-info-pharma'
  private readonly INFO_FEDICOM_API_END: string = '/pharma-info-management/get-info-fedicom'
  private readonly INSERT_FEDICOM_API_END: string = '/pharma-info-management/add-fedicom'
  private readonly UPDATE_FEDICOM_API_END: string = '/pharma-info-management/update-fedicom'
  private readonly DELETE_FEDICOM_API_END: string = '/pharma-info-management/delete-fedicom'
  private readonly TRY_FEDICOM_API_END: string = '/pharma-info-management/try-fedicom'
  private readonly ENABLE_FEDICOM_API_END: string = '/pharma-info-management/enable-fedicom'
  private readonly RESTORE_FEDICOM_API_END: string = '/pharma-info-management/restore-fedicom'
  private readonly SELECT_FEDICOM_API_END: string = '/pharma-info-management/select-fedicom'
  private readonly ADD_FARMACIA_API_END: string = '/pharma-info-management/add-pharmacy'
  private readonly UPDATE_FARMACIA_API_END: string = '/pharma-info-management/update-pharmacy'
  private readonly DELETE_FARMACIA_API_END: string = '/pharma-info-management/delete-pharmacy'
  private readonly GET_MUNICIPIOS_API_END: string = '/pharma-info-management/municipios'
  private readonly POST_GENERAR_ID_API_END: string = '/pharma-info-management/generar-id'
  private readonly OBTENER_PLACE_ID_API_END: string = '/pharma-info-management/get-place-id'
  private readonly OBTENER_IDS_NOMBRES_API_END: string = '/pharma-info-management/get-lista-ids'
  private readonly ANYDESK_API_END: string = '/pharma-info-management/get-anydesk'
  private readonly ADD_ANYDESK_API_END: string = '/pharma-info-management/add-anydesk'
  private readonly UPDATE_ANYDESK_API_END: string = '/pharma-info-management/update-anydesk'
  private readonly DELETE_ANYDESK_API_END: string = '/pharma-info-management/delete-anydesk'
  private readonly ANYDESK_PASSWORD_API_END: string = '/pharma-info-management/get-anydesk-password'
  private readonly PROGRAMACION_TAREAS_API_END: string = '/order-management/get-task-prog'
  private readonly PROGRAMACION_TAREAS_V2_API_END: string = '/tasks/get-calendar'
  private readonly INSERT_PROGRAMACION_TAREAS_API_END: string = '/order-management/insert-task-prog'
  private readonly INSERT_PROGRAMACION_TAREAS_V2_API_END: string = '/tasks/insert-schedule-task'
  private readonly UPDATE_PROGRAMACION_TAREAS_API_END: string = '/order-management/update-task-prog'
  private readonly UPDATE_PROGRAMACION_TAREAS_V2_API_END: string = '/tasks/update-schedule-task'
  private readonly DELETE_PROGRAMACION_TAREAS_API_END: string = '/order-management/delete-task-prog'
  private readonly DELETE_PROGRAMACION_TAREAS_V2_API_END: string = '/tasks/delete-schedule-task'
  private readonly FARMAIA_METADATA_API_END: string = '/app-status-management/get-metadata'
  private readonly FARMAIA_COST_DASHBOARD_API_END: string = '/app-status-management/get-cost-dashboard'
  private readonly FARMAIA_TRAINING_API_END: string = '/app-status-management/get-training-data'
  private readonly FARMAIA_TRAINING_API_UPDATE_END: string = '/app-status-management/update-training-data'
  private readonly FARMAIA_TRAINING_API_EMBED_END: string = '/app-status-management/embed-training-data'
  private readonly USAGE_DATA_API_END: string = '/app-status-management/get-usage-data'
  private readonly CONTROL_CALIDAD_DETALLE_API_END: string = '/data-quality-management/get-control-calidad-detalle'
  private readonly EMAIL_REPORTING_OPTIONS_API_END: string = '/email-reporting/options'
  private readonly EMAIL_REPORTING_DASHBOARD_API_END: string = '/email-reporting/dashboard'
  private readonly EMAIL_REPORTING_MAILRELAY_OPTIONS_API_END: string = '/email-reporting/mailrelay/options'
  private readonly EMAIL_REPORTING_MAILRELAY_DASHBOARD_API_END: string = '/email-reporting/mailrelay/dashboard'
  private readonly VACATIONS_API_END: string = '/vacations'
  private readonly RMM_API_END: string = '/rmm'

  //FEDICOM DESCARGAS
  private readonly OBTENER_IDS_NOMBRES_CON_FEDICOM_API_END: string = '/pharma-info-management/get-users-list-with-fedicom'
  private readonly OBTENER_IDS_END_POINT_PROVEEDORES_API_END: string = '/pharma-info-management/get-proveedores-farma-fedicom'
  private readonly OBTENER_SELECTED_ALBARANES_API_END: string = '/pharma-info-management/get-selected-albaranes'
  private readonly DESCARGAR_ALBARAN_PDF_API_END: string = '/pharma-info-management/download-albaran-pdf'

  get obtenerIdsNombresConFedicomApi(): string {
    return `${this.urlApiEndV3}${this.OBTENER_IDS_NOMBRES_CON_FEDICOM_API_END}`;
  }

  get hfappApi(): string { return `${this.urlApiEndV3}/hfapp`; }

  get rmmApi(): string {
    return `${this.urlApiEndV3}${this.RMM_API_END}`;
  }

  get obtenerEndPointsFedicom(): string {
    return `${this.urlApiEndV3}${this.OBTENER_IDS_END_POINT_PROVEEDORES_API_END}`;
  }

  get obtenerSelectedAlbaranesFedicom(): string {
    return `${this.urlApiEndV3}${this.OBTENER_SELECTED_ALBARANES_API_END}`;
  }

  get descargarAlbaranPdfFedicom(): string {
    return `${this.urlApiEndV3}${this.DESCARGAR_ALBARAN_PDF_API_END}`;
  }

  // ORDENES DE EJECUCION SERVICE BUS
  private readonly TASK_GENERIC_API_END: string = '/tasks'
  private readonly POST_CREATE_TASK_API_END: string = '/tasks'
  private readonly TASK_FINGERPRINTS_API_END: string = '/tasks/fingerprints'
  private readonly TASK_FINGERPRINTS_UNYCOP_API_END: string = '/tasks/fingerprints_unycop'
  private readonly TASK_FINGERPRINTS_FARMANAGER_API_END: string = '/tasks/fingerprints_farmanager'
  private readonly TASK_HEARTBEATS_API_END: string = '/tasks/heartbeats'
  private readonly TASK_HEARTBEATS_UNYCOP_API_END: string = '/tasks/heartbeats_unycop'
  private readonly SAVE_TASK_SCRIPT_API_END: string = '/tasks/save-script'
  private readonly TASK_CONTROL_PANEL_API_END: string = '/tasks/control-panel'
  private readonly TASK_SERVICE_BUS_CHECK_API_END: string = '/tasks/service-bus-check'

  // WHATSAPP

  private readonly WHATSAPP_LIST_API_END = '/whatsapp/get-conversations';
  private readonly WHATSAPP_DETAILS_API_END = '/whatsapp/get-conversation-details';
  private readonly WHATSAPP_SEND_MESSAGE_API_END = '/whatsapp/send-message';

  // MAP COORDS

  private readonly MAP_COORDS_API_END = '/pharma-info-management/get-coordenadas-farmacias';
  private readonly MAP_COORDS_COMPETENCIA_API_END = '/pharma-info-management/get-competencia';

  get whatsappListAPI(): string {
    return `${this.urlApiEndV3}${this.WHATSAPP_LIST_API_END}`;
  }

  get whatsappDetailsAPI(): string {
    return `${this.urlApiEndV3}${this.WHATSAPP_DETAILS_API_END}`;
  }

  get whatsappSendMessageAPI(): string {
    return this.urlApiEndV3 + this.WHATSAPP_SEND_MESSAGE_API_END;
  }

  get whatsappDeleteMessageAPI(): string {
    return this.urlApiEndV3 + '/whatsapp/delete-message';
  }

  // PANEL DE CONTROL
  private readonly UPLOAD_CONTROL_API_END: string = '/data-upload-management/get-upload-control'
  private readonly PARTIAL_UPLOAD_API_END: string = '/data-upload-management/get-partial-upload'
  private readonly UPLOAD_STATUS_DATABRICKS_API_END: string = '/data-upload-management/get-upload-status-databricks'
  private readonly UPLOAD_STATUS_DIGITAL_DATABRICKS_API_END: string = '/data-upload-management/get-upload-status-digital-databricks'

  get uploadControlApi(): string {
    return `${this.urlApiEndV3}${this.UPLOAD_CONTROL_API_END}`;
  }

  get partialUploadApi(): string {
    return `${this.urlApiEndV3}${this.PARTIAL_UPLOAD_API_END}`;
  }

  get uploadStatusDatabricksApi(): string {
    return `${this.urlApiEndV3}${this.UPLOAD_STATUS_DATABRICKS_API_END}`;
  }

  get uploadStatusDigitalDatabricksApi(): string {
    return `${this.urlApiEndV3}${this.UPLOAD_STATUS_DIGITAL_DATABRICKS_API_END}`;
  }

  // DEBUG

  private readonly POLLING_API_END: string = '/debug/get-polling'
  private readonly ERROR_STATUS_API_END: string = '/debug/get-error-list'
  private readonly LOGS_API_END: string = '/debug/get-log-data'

  get logsApi(): string {
    return `${this.urlApiEndV3}${this.LOGS_API_END}`;
  }

  get pollingApi(): string {
    return `${this.urlApiEndV3}${this.POLLING_API_END}`;
  }

  get statusApi(): string {
    return `${this.urlApiEndV3}${this.ERROR_STATUS_API_END}`;
  }

  // LOGIN

  get executionRegApi(): string {
    return `${this.urlApiEndV3}${this.EXECUTION_REG_API_END}`;
  }

  get addExecutionRegApi(): string {
    return `${this.urlApiEndV3}${this.ADD_EXECUTION_REG_API_END}`;
  }

  get deleteExecutionRegApi(): string {
    return `${this.urlApiEndV3}${this.DELETE_EXECUTION_REG_API_END}`;
  }


  get userInfoRecoverApi(): string {
    return `${this.urlApiEndV3}${this.USER_INFO_RECOVER_API_END}`;
  }

  get packageInfoApi(): string {
    return `${this.urlApiEndV3}${this.PACKAGE_INFO_API_END}`;
  }

  get updatePackageApi(): string {
    return `${this.urlApiEndV3}${this.UPDATE_PACKAGE_API_END}`;
  }

  get insertPackageApi(): string {
    return `${this.urlApiEndV3}${this.INSERT_PACKAGE_API_END}`;
  }

  get deletePackageApi(): string {
    return `${this.urlApiEndV3}${this.DELETE_PACKAGE_API_END}`;
  }

  get groupCatalogApi(): string {
    return `${this.urlApiEndV3}${this.GROUP_CATALOG_API_END}`;
  }

  get groupMembershipsApi(): string {
    return `${this.urlApiEndV3}${this.GROUP_MEMBERSHIPS_API_END}`;
  }

  get groupConfigurationApi(): string {
    return `${this.urlApiEndV3}${this.GROUP_CONFIGURATION_API_END}`;
  }

  get savePackageConfigurationApi(): string {
    return `${this.urlApiEndV3}${this.SAVE_PACKAGE_CONFIGURATION_API_END}`;
  }

  get infoPharmaApi(): string {
    return `${this.urlApiEndV3}${this.INFO_PHARMACIA_API_END}`;
  }

  get anydeskApi(): string {
    return `${this.urlApiEndV3}${this.ANYDESK_API_END}`;
  }

  get addAnydeskApi(): string {
    return `${this.urlApiEndV3}${this.ADD_ANYDESK_API_END}`;
  }

  get updateAnydeskApi(): string {
    return `${this.urlApiEndV3}${this.UPDATE_ANYDESK_API_END}`;
  }

  get deleteAnydeskApi(): string {
    return `${this.urlApiEndV3}${this.DELETE_ANYDESK_API_END}`;
  }

  get anydeskPasswordApi(): string {
    return `${this.urlApiEndV3}${this.ANYDESK_PASSWORD_API_END}`;
  }

  get infoFedicom(): string {
    return `${this.urlApiEndV3}${this.INFO_FEDICOM_API_END}`;
  }

  get insertFedicom(): string {
    return `${this.urlApiEndV3}${this.INSERT_FEDICOM_API_END}`;
  }

  get updateFedicom(): string {
    return `${this.urlApiEndV3}${this.UPDATE_FEDICOM_API_END}`;
  }

  get closeFedicom(): string {
    return `${this.urlApiEndV3}/pharma-info-management/close-fedicom`;
  }

  get purgeFedicom(): string {
    return `${this.urlApiEndV3}/pharma-info-management/purge-fedicom`;
  }

  get deleteFedicom(): string {
    return `${this.urlApiEndV3}${this.DELETE_FEDICOM_API_END}`;
  }

  get tryFedicom(): string {
    return `${this.urlApiEndV3}${this.TRY_FEDICOM_API_END}`;
  }

  get enableFedicom(): string {
    return `${this.urlApiEndV3}${this.ENABLE_FEDICOM_API_END}`;
  }

  get restoreFedicom(): string {
    return `${this.urlApiEndV3}${this.RESTORE_FEDICOM_API_END}`;
  }

  get selectFedicom(): string {
    return `${this.urlApiEndV3}${this.SELECT_FEDICOM_API_END}`;
  }


  get addPharmacyApi(): string {
    return `${this.urlApiEndV3}${this.ADD_FARMACIA_API_END}`;
  }

  get updatePharmacyApi(): string {
    return `${this.urlApiEndV3}${this.UPDATE_FARMACIA_API_END}`;
  }

  get deletePharmacyApi(): string {
    return `${this.urlApiEndV3}${this.DELETE_FARMACIA_API_END}`;
  }

  get getMunicipiosApi(): string {
    return `${this.urlApiEndV3}${this.GET_MUNICIPIOS_API_END}`;
  }

  get postGenerarIdApi(): string {
    return `${this.urlApiEndV3}${this.POST_GENERAR_ID_API_END}`;
  }

  get globalStatusApi(): string {
    return `${this.urlApiEndV3}${this.GLOBAL_STATUS_API_END}`;
  }

  get programacionTareasAPI(): string {
    return `${this.urlApiEndV3}${this.PROGRAMACION_TAREAS_API_END}`;
  }

  get programacionTareasV2API(): string {
    return `${this.urlApiEndV3}${this.PROGRAMACION_TAREAS_V2_API_END}`;
  }

  get genericoOrdenes(): string {
    return `${this.urlApiEndV3}${this.TASK_GENERIC_API_END}`;
  }

  get setOrdenNueva(): string {
    return `${this.urlApiEndV3}${this.POST_CREATE_TASK_API_END}`;
  }

  get fingerprintApi(): string {
    return `${this.urlApiEndV3}${this.TASK_FINGERPRINTS_API_END}`;
  }

  get fingerprintUnycopApi(): string {
    return `${this.urlApiEndV3}${this.TASK_FINGERPRINTS_UNYCOP_API_END}`;
  }

  get fingerprintFarmanagerApi(): string {
    return `${this.urlApiEndV3}${this.TASK_FINGERPRINTS_FARMANAGER_API_END}`;
  }

  get heartbeatApi(): string {
    return `${this.urlApiEndV3}${this.TASK_HEARTBEATS_API_END}`;
  }

  get heartbeatUnycopApi(): string {
    return `${this.urlApiEndV3}${this.TASK_HEARTBEATS_UNYCOP_API_END}`;
  }

  get fingerprintPuestosApi(): string {
    return `${this.urlApiEndV3}/tasks/fingerprints_puestos`;
  }

  get heartbeatAsistenteApi(): string {
    return `${this.urlApiEndV3}/tasks/heartbeats_asistente`;
  }

  get saveTaskScriptApi(): string {
    return `${this.urlApiEndV3}${this.SAVE_TASK_SCRIPT_API_END}`;
  }

  get taskControlPanelApi(): string {
    return `${this.urlApiEndV3}${this.TASK_CONTROL_PANEL_API_END}`;
  }

  get taskServiceBusCheckApi(): string {
    return `${this.urlApiEndV3}${this.TASK_SERVICE_BUS_CHECK_API_END}`;
  }

  get obtenerPlaceIdAPI(): string {
    return `${this.urlApiEndV3}${this.OBTENER_PLACE_ID_API_END}`;
  }

  get obtenerNombresIds(): string {
    return `${this.urlApiEndV3}${this.OBTENER_IDS_NOMBRES_API_END}`;
  }

  get mapCoordsAPI(): string {
    return `${this.urlApiEndV3}${this.MAP_COORDS_API_END}`;
  }

  get mapCoordsCompetenciaAPI(): string {
    return `${this.urlApiEndV3}${this.MAP_COORDS_COMPETENCIA_API_END}`;
  }

  get updateProgramacionTareasAPI(): string {
    return `${this.urlApiEndV3}${this.UPDATE_PROGRAMACION_TAREAS_API_END}`;
  }

  get updateProgramacionTareasV2API(): string {
    return `${this.urlApiEndV3}${this.UPDATE_PROGRAMACION_TAREAS_V2_API_END}`;
  }

  get deleteProgramacionTareasAPI(): string {
    return `${this.urlApiEndV3}${this.DELETE_PROGRAMACION_TAREAS_API_END}`;
  }

  get deleteProgramacionTareasV2API(): string {
    return `${this.urlApiEndV3}${this.DELETE_PROGRAMACION_TAREAS_V2_API_END}`;
  }

  get insertProgramacionTareasAPI(): string {
    return `${this.urlApiEndV3}${this.INSERT_PROGRAMACION_TAREAS_API_END}`;
  }

  get insertProgramacionTareasV2API(): string {
    return `${this.urlApiEndV3}${this.INSERT_PROGRAMACION_TAREAS_V2_API_END}`;
  }

  get farmaIaMetadataApi(): string {
    return this.hermesMetadataApi;
  }

  get farmaIaCostDashboardApi(): string {
    return this.hermesCostDashboardApi;
  }

  get farmaIaTrainingApi(): string {
    return this.hermesTrainingApi;
  }

  get farmaIATrainingUpdateApi(): string {
    return this.hermesTrainingUpdateApi;
  }

  get farmaIATrainingEmbed(): string {
    return this.hermesTrainingEmbedApi;
  }

  get usageDataApi(): string {
    return `${this.urlApiEndV3}${this.USAGE_DATA_API_END}`;
  }

  get controlCalidadDetalleApi(): string {
    return `${this.urlApiEndV3}${this.CONTROL_CALIDAD_DETALLE_API_END}`;
  }

  get emailReportingOptionsApi(): string {
    return `${this.urlApiEndV3}${this.EMAIL_REPORTING_OPTIONS_API_END}`;
  }

  get emailReportingDashboardApi(): string {
    return `${this.urlApiEndV3}${this.EMAIL_REPORTING_DASHBOARD_API_END}`;
  }

  get emailReportingMailrelayOptionsApi(): string {
    return `${this.urlApiEndV3}${this.EMAIL_REPORTING_MAILRELAY_OPTIONS_API_END}`;
  }

  get emailReportingMailrelayDashboardApi(): string {
    return `${this.urlApiEndV3}${this.EMAIL_REPORTING_MAILRELAY_DASHBOARD_API_END}`;
  }

  get vacationsPeopleApi(): string {
    return `${this.urlApiEndV3}${this.VACATIONS_API_END}/people`;
  }

  get vacationsCalendarApi(): string {
    return `${this.urlApiEndV3}${this.VACATIONS_API_END}/calendar`;
  }

  get vacationsSummaryApi(): string {
    return `${this.urlApiEndV3}${this.VACATIONS_API_END}/summary`;
  }

  get vacationsDaysApi(): string {
    return `${this.urlApiEndV3}${this.VACATIONS_API_END}/days`;
  }

  get vacationsDaysRangeApi(): string {
    return `${this.urlApiEndV3}${this.VACATIONS_API_END}/days/range`;
  }
}
